import React, { useEffect, useRef, useState } from "react"
import { deserialize } from "jsonapi-deserializer"
import { useParams } from "react-router-dom"

import consumer from "~/channels/consumer"
import { postEvent } from "~/utils/EventManager"

export const SharedSpaceContext = React.createContext(null)

export default function SharedSpaceProvider({ children }) {
  const [space, setSpace] = useState(null)
  const [cycle, setCycle] = useState("work")
  const { shareToken } = useParams()
  const subscription = useRef(null)

  const switchCycle = () =>
    setCycle((prev) => (prev === "work" ? "break" : "work"))

  useEffect(() => {
    subscription.current = consumer.subscriptions.create(
      { channel: "SpaceChannel", shareToken },
      {
        connected() {
          postEvent({ shareToken }, "userConnected")
        },

        received(data) {
          const spaceData = deserialize(data["value"])
          if (spaceData.current_timer) {
            if (spaceData.current_timer.break) setCycle("break")
            else setCycle("work")
          }

          if (data.type === "timerEnded") {
            setCycle(data.timer.data.attributes.break ? "work" : "break")
            spaceData.current_timer = null
          }

          setSpace((prev) => ({
            ...prev,
            ...spaceData,
          }))
        },
      }
    )

    return () => {
      subscription?.current?.unsubscribe()
    }
  }, [shareToken])

  if (!space) return null

  return (
    <SharedSpaceContext.Provider
      value={{ shareToken, space, cycle, switchCycle }}
    >
      {children}
    </SharedSpaceContext.Provider>
  )
}
